import * as React from "react";
import { IdStyles } from "../../../less/IdStyles";
import { utilTime } from "../../../utils/utilTime";
import { TextLoca } from "../../generic/text/TextLoca";
export var CoopCreationDateBolt = function (_a) {
    var creationTime = _a.creationTime;
    return (React.createElement("div", { className: IdStyles.CoopDateContainer + "  date-bolt flex" },
        React.createElement("div", { className: IdStyles.CoopDateContainerShine },
            React.createElement("div", { className: IdStyles.CoopDateContainerBolt + " date-bolt date-bolt__top date-bolt__top_right" }),
            React.createElement("div", { className: IdStyles.CoopDateContainerBolt + " date-bolt date-bolt__top date-bolt__top_left" }),
            React.createElement("div", { className: IdStyles.CoopDateContainerBolt + " date-bolt date-bolt__bottom date-bolt__bottom_right" }),
            React.createElement("div", { className: IdStyles.CoopDateContainerBolt + " date-bolt date-bolt__bottom date-bolt__bottom_left" }),
            creationTime && (React.createElement(TextLoca, { className: IdStyles.TextNormal, id: utilTime.secondsFromCreationDateToString(creationTime) })))));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/cooperative/info-view/CoopCreationDateBolt.tsx
// module id = 2608
// module chunks = 3